


















































































/* eslint-disable no-unused-vars */
import Component, { mixins } from "vue-class-component";
import { BarLoader } from "@saeris/vue-spinners";
import { GenericOutcome } from "@/util/commonTypes";
import VFormControl from "@/components/UI/VFormControl.vue";
import VAutocomplete from "@/components/UI/VAutocomplete.vue";
import acOptions from "@/mixins/acOptions";
import { moveMultiple } from "@/services/move";
import Vue from "vue";

enum AddOutcomes {
  Added = "ADDED",
  Invalid = "INVALID",
  Duplicate = "DUPLICATE"
}


@Component({
  props: {
    initialLocation: {
      type: String,
      required: false,
    },
    focusOnCreated: {
      type: Boolean,
      default: false,
    }
  },
  components: { VAutocomplete, VFormControl, VScanner: () => import("@/components/UI/VScanner.vue"), BarLoader },
})
export default class Move extends mixins(acOptions) {
  instrumentNumbers: string[] = [];
  currentNumber = "";
  scanner = false;
  loading = false;
  flash = false;
  location = "";

  initialLocation!: string | never;
  focusOnCreated!: boolean;

  async created(): Promise<void> {
    if (this.initialLocation) {
      this.location = this.initialLocation;
    }
    await this.getACOptions();
  }

  mounted(): void {
    if (this.focusOnCreated) {
      const box = this.$refs.numberInputBox as Vue & { focus: () => void};
      setTimeout(() => {
        box.focus();
      }, 500)
    }
  }

  async onSubmit(): Promise<void> {
    if (this.instrumentNumbers.length < 1) {
      this.$toasted.error("No Instruments to move", { duration: 2000 });
      return;
    }

    this.loading = true;
    const [outcome, result] = await moveMultiple(this.instrumentNumbers, this.location);
    this.loading = false;

    switch (outcome) {
      case GenericOutcome.Ok:
        this.handleUpdated(result.instrumentsUpdated);
        this.handleFailed(result.instrumentsFailed);
        break;
      case GenericOutcome.Err:
        this.$toasted.error(`Error: ${result}`, { duration: 2000 });
        console.error(result);
        break;
      default:
        this.$toasted.error("Something went wrong", { duration: 1000 });
    }
  }

  handleUpdated(updatedNumbers: string[]): void {
    if (updatedNumbers.length > 0) {
      this.$toasted.success(`Successfully moved ${updatedNumbers.join(", ")}`, { duration: 4000 });
    }
  }

  handleFailed(failedNumbers: string[]): void {
    if (failedNumbers.length > 0) {
      this.$toasted.success(`Failed to move ${failedNumbers.join(", ")}`, { duration: 4000 });
    }
  }

  onAdd(): void {
    switch (this.doAdd(this.currentNumber)) {
      case AddOutcomes.Added:
        this.currentNumber = "";
        break;
      case AddOutcomes.Duplicate:
        this.currentNumber = "";
        this.$toasted.info("Instrument already added", { duration: 900 });
        break;
      case AddOutcomes.Invalid:
        this.$toasted.error("Invalid Instrument number", { duration: 1000 });
        break;
      default:
        this.$toasted.error("Something went wrong", { duration: 1000 });
    }
  }

  detected(result: { codeResult: { code: string } }): void {
    switch (this.doAdd(result.codeResult.code)) {
      case AddOutcomes.Added:
        this.doFlash();
        break;
      case AddOutcomes.Duplicate:
      case AddOutcomes.Invalid:
        break;
      default:
        this.$toasted.error("Something went wrong", { duration: 1000 });
    }
  }

  remove(instrument: string): void {
    this.instrumentNumbers = this.instrumentNumbers.filter(item => item !== instrument);
  }

  doFlash(timeout = 300): void {
    this.flash = true;
    setTimeout(() => this.flash = false, timeout);
  }

  doAdd(number: string): AddOutcomes {
    if (!number.match(/\w*\d*-\d+/)) {
      return AddOutcomes.Invalid;
    }
    if (this.instrumentNumbers.includes(number)) {
      return AddOutcomes.Duplicate;
    }
    this.instrumentNumbers.push(number);
    return AddOutcomes.Added;
  }
}
